export default __webpack_public_path__ + "static/media/stats.ee439874.png";